import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/pages/home';
import Detail from '@/pages/detail';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/detail',
      name: 'Detail',
      component: Detail
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js